var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.725 5.375C2.4 5.075 2.4 4.55 2.725 4.25L5.925 1.05C6.075 0.9 6.275 0.8 6.5 0.8C6.7 0.8 6.9 0.9 7.05 1.05L10.25 4.25C10.575 4.55 10.575 5.075 10.25 5.375C9.95 5.7 9.425 5.7 9.125 5.375L7.3 3.55V9.6C7.3 10.05 6.925 10.4 6.5 10.4C6.05 10.4 5.7 10.05 5.7 9.6V3.55L3.85 5.375C3.55 5.7 3.025 5.7 2.725 5.375ZM12.1 9.6C12.525 9.6 12.9 9.975 12.9 10.4V12.8C12.9 13.25 12.525 13.6 12.1 13.6H0.9C0.45 13.6 0.0999999 13.25 0.0999999 12.8V10.4C0.0999999 9.975 0.45 9.6 0.9 9.6H4.9C4.9 10.5 5.6 11.2 6.5 11.2C7.375 11.2 8.1 10.5 8.1 9.6H12.1ZM10.9 12.2C11.225 12.2 11.5 11.95 11.5 11.6C11.5 11.275 11.225 11 10.9 11C10.55 11 10.3 11.275 10.3 11.6C10.3 11.95 10.55 12.2 10.9 12.2Z",
    fill: "#E9EBEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadWhite);
export default __webpack_public_path__ + "static/media/UploadWhite.5309923bbc19396711463404113a5753.svg";
export { ForwardRef as ReactComponent };